"use strict";

var _defineProperty = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/defineProperty");

var _objectWithoutProperties = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/objectWithoutProperties");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconGraphUp = void 0;

var React = __importStar(require("react"));

exports.IconGraphUp = React.forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return React.createElement("svg", _objectSpread(_objectSpread({
    width: "40",
    height: "36",
    viewBox: "0 0 40 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    ref: forwardedRef
  }), React.createElement("path", {
    d: "M40 34.582C40 35.2734 39.4395 35.832 38.75 35.832H3.334C1.4961 35.832 0 34.3359 0 32.498V1.25C0 0.5586 0.56055 0 1.25 0C1.93945 0 2.5 0.5586 2.5 1.25V32.5C2.5 32.9609 2.875 33.334 3.334 33.334H38.75C39.4395 33.332 40 33.8907 40 34.5821V34.582ZM8.7695 25.287C9.08786 25.287 9.40815 25.164 9.6523 24.9198L18.9708 15.6013C19.295 15.2771 19.8243 15.2771 20.1505 15.6013L23.3575 18.8084C24.6153 20.0662 26.8126 20.0662 28.0704 18.8084L36.623 10.2559V14.2695C36.623 14.9609 37.1835 15.5195 37.873 15.5195C38.5624 15.5195 39.123 14.959 39.123 14.2695L39.121 7.23851C39.121 7.0764 39.0878 6.91429 39.0253 6.76195C38.8983 6.45531 38.6542 6.21115 38.3495 6.0842C38.1971 6.0217 38.035 5.9885 37.8729 5.9885H30.8419C30.1525 5.9885 29.5919 6.54905 29.5919 7.2385C29.5919 7.92795 30.1525 8.48849 30.8419 8.48849H34.8556L26.3046 17.0395C25.9804 17.3637 25.4511 17.3637 25.1249 17.0395L21.9178 13.8324C20.619 12.5316 18.5038 12.5316 17.2049 13.8324L7.88643 23.1509C7.39815 23.6392 7.39815 24.4302 7.88643 24.9205C8.13057 25.1646 8.44893 25.2877 8.76923 25.2877L8.7695 25.287Z",
    fill: color
  }));
});